define('views/filter-list',['require','jquery','views/base/view','text!templates/filter-list.ejs'],function(require) {
    'use strict';

    var $ = require('jquery'),
        View = require('views/base/view'),
        template = require('text!templates/filter-list.ejs');

    var FilterListView = View.extend({
        autoRender: true,
        className: 'btn-group menu-show-filter',
        template: template,

        region: 'navbar',

        events: {
            'click button': 'onClick',
            'click a': 'onClick'
        },

        listen: {
            'render model': 'render',
            'afterLoad model': 'render'
        },

        onClick: function(ev) {
            var $button = $(ev.currentTarget);

            var action = $button.data('action');

            switch (action) {
                case 'show':
                    this.model.showFilter();
                    break;
                case 'select':
                    this.model.selectFilter($button.data('id'));
                    break;
                case 'delete':
                    this.model.deleteFilter($button.data('id'));
                    break;
            }
        }
    });

    return FilterListView;
});

